/** QR payload and parsing per TZ v1.2 §4.2 */

const DR_ID_RE = /^DR-[A-Z0-9]{2,12}-[A-Z0-9]{6}$/;

export function buildDoctorQrPayload(doctorPublicId: string): Record<string, unknown> {
  return {
    schema: 'compass-mom',
    v: 1,
    type: 'doctor_public_id',
    id: doctorPublicId.trim(),
  };
}

export function parseDoctorIdFromQrText(text: string): string | null {
  const trimmed = (text || '').trim();
  if (!trimmed) return null;
  if (DR_ID_RE.test(trimmed)) return trimmed;
  try {
    const data = JSON.parse(trimmed);
    const id = data?.id ?? data?.doctor_public_id;
    if (typeof id === 'string' && DR_ID_RE.test(id.trim())) {
      return id.trim();
    }
  } catch {
    /* not JSON */
  }
  return null;
}

export function doctorQrJsonString(doctorPublicId: string): string {
  return JSON.stringify(buildDoctorQrPayload(doctorPublicId));
}
